const applicantDetailsInitialState = {
    applicant: {
        name: '',
        surname: '',
        dateOfBirth: '',
        address: {
            city: '',
            postalCode: '',
            street: '',
            houseNumber: '',
        },
        phone: '',
        idVerification: {},
        incomeCheck: {
            uuid: '',
            decision: '',
            result: {},
            data: {},
        },
    },
    showError: {
        name: false,
        surname: false,
        dateOfBirth: false,
        addressCity: false,
        addressPostalCode: false,
        addressStreet: false,
        addressHouseNumber: false,
        phone: false,
    },
};

export default applicantDetailsInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetails/applicantDetailsInitialState.js